var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('ul',{staticClass:"filters__facet-list"},_vm._l((_vm.filters),function(filter){return _c('FacetDropdown',_vm._b({key:filter.name,attrs:{"checkedFilters":_vm.currentRefinements[filter.name]},on:{"select-filter":_vm.handleSelectFilter}},'FacetDropdown',{
        name: filter.name,
        data: filter.data,
        icon: filter.icon || '',
        single: filter.single || false,
      },false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }